import { type Template } from '../entities/Template'

const template: Template = {
  header: {
    showPopover: false,
    showMenuPrivate: false,
    showPublicMenu: false,
    showShare: false,
    showMenu: false,
  },
}

export default template
